export class LocationDto {
    refNo: number;
    locationName: string;
    stateCode: number;
    address: string;
    pin: string;
}